module.exports = __webpack_public_path__ + "img/mr-game-and-watch-min.11af7ef8.png";